module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/menu-5d38d9f825fe23078f76a9598a723832.png";